<template>
  <div class="vx-row mb-6">
    <div class="vx-col w-full">
      <h5 class="mb-6">
        {{ $t('Devices') }}
      </h5>
      <vs-row>
        <vs-col v-for="(device, index) in targetDevices" :key="'target-device-' + adsetIndex + '-' + index" vs-type="flex" vs-justify="start" vs-align="center" vs-w="4">
          <vx-tooltip v-if="isDeviceDisabled(device.id)" :text="$t('adset_targeting.desktop_disabled_hint')" position="right">
            <vs-checkbox :checked="false" :disabled="true" id="create-campaign-s3-devices-checkbox" class="ml-0 disabled-device">{{ $t(device.display_name) }}</vs-checkbox>
          </vx-tooltip>

          <vs-checkbox v-else-if="isDeviceUnchecked(device.id)" :checked="false" id="create-campaign-s3-devices-checkbox" class="ml-0" v-model="devices" :vs-value="device.id">{{ $t(device.display_name) }}</vs-checkbox>

          <vs-checkbox v-else @input="gaDevices(device)" id="create-campaign-s3-devices-checkbox" class="ml-0" v-model="devices" :vs-value="device.id">{{ $t(device.display_name) }}</vs-checkbox>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    adsetIndex: {
      type: Number,
      required: true
    },
    objective: {
      type: String,
      required: false
    }
  },

  mounted () {
    this.$emit('input', this.removeDisabledDevices(this.value))
  },

  computed: {
    targetDevices () {
      return this.$store.getters['campaign/targetingLookups'].devices
    },

    disabledDevices () {
      return this.objective === this.$constants.CAMPAIGN_OBJECTIVES_NAMES.LEAD_FORM ? [this.$constants.DEVICES_IDS.DESKTOP] : []
    },

    devices: {
      set (val) {
        this.$emit('input', val)
      },
      get () {
        return this.removeDisabledDevices(this.value)
      }
    }
  },
  methods: {
    gaDevices (device) {
      this.$gtag.event(`Step3_Devices_${device.display_name}`)
    },

    isDeviceDisabled (deviceId) {
      return this.objective === this.$constants.CAMPAIGN_OBJECTIVES_NAMES.LEAD_FORM && this.disabledDevices.includes(deviceId)
    },

    isDeviceUnchecked (deviceId) {
      return !this.devices.includes(deviceId)
    },

    removeDisabledDevices (devices) {
      return devices.filter(id => !this.disabledDevices.includes(id))
    }
  }
}
</script>

<style lang="scss" scoped>
.disabled-device {
  color: #c2c2c2;
  cursor: not-allowed;
}
</style>
